"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noCountry = void 0;
var _utils = require("../utils");
// i18next-extract-mark-ns-start Countries

var noCountry = exports.noCountry = function noCountry(t) {
  return {
    id: 'NO',
    name: t('Norway'),
    flag: '🇳🇴',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      var regex = /^[0-9]{4}$/;
      return regex.test(zipcode);
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 1000 or 4000',
    phonePrefix: '47',
    phoneLength: 8,
    unavailable: true,
    pricingVersion: 14,
    timezone: 'Europe/Oslo',
    currency: 'EUR'
  };
};